<template>
  <div>
    <HeaderReceipt header="ดูรายละเอียดใบสั่งซื้อ" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StoragePO_detail/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/completed-task.png";
import StoragePO_detail from "@/components/admin/stock/po/StoragePO_detail";
export default {
  name: "PoDetail",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    StoragePO_detail,
    HeaderReceipt
  }
}
</script>

<style scoped>

</style>
